<template>
  <div id="create">
    <v-container fluid id="edit-profile-view" class="px-0">
      <v-row justify="center" align="center">
        <v-col cols="12" md="6">
          <v-card>
            <v-card-text>
              <v-container fluid>
                <v-form v-model="validEdit">
                  <v-row dense>
                    <v-col cols="12">
                      <v-text-field
                        v-model="oldPassword"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="nameRules"
                        :type="show1 ? 'text' : 'password'"
                        name="oldPassword"
                        label="Old Password"
                        counter
                        @click:append="show1 = !show1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="newPassword"
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="reqRules"
                        :type="show2 ? 'text' : 'password'"
                        name="newPassword"
                        label="New Password"
                        counter
                        @click:append="show1 = !show1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="confirmPassword"
                        :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="rules"
                        :type="show3 ? 'text' : 'password'"
                        name="confirmPassword"
                        label="Confirm Password"
                        counter
                        @click:append="show1 = !show1"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col justify="end" align="end">
                      <v-btn
                        color="blue darken-1"
                        :loading="saveLoading"
                        text
                        @click="saveProfile"
                        :disabled="!validEdit"
                      >
                        Change Password
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { get } from "vuex-pathify";
import { getPermissions } from "../util/helpers";
import { showSnackbar } from "../util/globalActions";
export default {
  name: "ChangePassword",
  
  data: () => ({
    reqRules: [
        value => !!value || 'Please enter a password',
        value => (value && value.length >= 6) || 'Minimum 6 characters',
        value => (value && /.*[A-Z].*/.test(value)) || 'Must contain at least one uppercase letter',
        value => (value && /.*[a-z].*/.test(value)) || 'Must contain at least one lowercase letter',
        value => (value && /.*[0-9].*/.test(value)) || 'Must contain at least one number',
        /* eslint-disable-next-line */
        value => (value && /.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/g.test(value)) || 'Must contain at least one special character',
      ],
    nameRules: [(v) => !!v || "Field is required"],
    validEdit: false,
    permission: {
      isAdd: false,
      isEdit: false,
      isDelete: false,
      isDownload: false,
    },
    saveLoading: false,
    show1: false,
    show2: false,
    show3: false,
    oldPassword: null,
    newPassword: null,
    confirmPassword: null,
    message: "",
    snackbar: false,
  }),
  created() {},
  mounted() {
    const self = this;
    self.permission = getPermissions(
      self.apiUrl + "api/Menus/permissions/",
      self.$route.path.replace("/", "")
    );
  },
  computed: {
    rules() {
      return [
        (v) => !!v || "Field is required",
        (v) =>
          v === this.newPassword ||
          `The new password and confirm password you entered don't match`,
      ];
    },
    apiUrl: get("app/apiUrl"),
  },
  watch: {},
  methods: {
    saveProfile() {
      const self = this;

      self.saveLoading = true;
      axios({
        url: self.apiUrl + "api/Users/updatepassword",
        data: { oldpassword: self.oldPassword, newpassword: self.newPassword },
        method: "POST",
        responseType: "json",
      })
        .then(function(res) {
          self.saveLoading = false;
          showSnackbar({ message: res.data.message });
          if (res.data.status === "OK") {
            self.$store.dispatch("user/logout").then(() => {
              self.$router.replace({ name: "Login" });
            });
          }
          
        })
        .catch(function(err) {
          self.saveLoading = false;
          self.message = err.status;

          showSnackbar({ message: "Error while update password!" });
        });
    },
  },
  beforeDestroy() {},
};
</script>
